angular.module('app.filters').filter('getById', () => (items, id, key, newValue) => {
    let found = null;
    const insert = 'undefined' !== typeof newValue;
    key = key || 'id';

    angular.forEach(items, (item, i) => {
        if (id == item[key]) {
            if (insert) {
                items[i] = angular.copy(newValue);
            }

            found = angular.copy(item);
        }
    });

    if (insert && null === found) {
        items.push(newValue);
        found = angular.copy(newValue);
    }

    return found;
});
